export const actionLogMessageType: Readonly<any> = {
    Script: 1,
    Log: 2
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/constants/actionLogMessageType.ts